import script from "./OpeningHoursItem.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningHoursItem.vue?vue&type=script&setup=true&lang=js"

import "./OpeningHoursItem.vue?vue&type=style&index=0&id=0034b48a&lang=scss"

const __exports__ = script;

export default __exports__